import { useState } from 'react';
import { IFilters } from '../../hooks/useAnalytics';

export const useAnalyticsFilterHandler = () => {
    const [filterArtistIds, setFilterArtistIds] = useState<string[]>([]);
    const [filterLabelIds, setFilterLabelIds] = useState<string[]>([]);
    const [filterPlatformIds, setFilterPlatformIds] = useState<string[]>([]);
    const [filterTerritoryIds, setFilterTerritoryIds] = useState<string[]>([]);
    const [filterReleaseIds, setFilterReleaseIds] = useState<string[]>([]);
    const [filterTrackIds, setFilterTrackIds] = useState<string[]>([]);
    const [filterDate, setFilterDate] = useState<Date[]>([]);

    const onSelectFilter = (filter: IFilters) => {
        filter.filterArtistIds && setFilterArtistIds(filter.filterArtistIds);
        filter.filterPlatformIds && setFilterPlatformIds(filter.filterPlatformIds);
        filter.filterLabelIds && setFilterLabelIds(filter.filterLabelIds);
        filter.filterTerritoryIds && setFilterTerritoryIds(filter.filterTerritoryIds);
        filter.filterReleaseIds && setFilterReleaseIds(filter.filterReleaseIds);
        filter.filterTrackIds && setFilterTrackIds(filter.filterTrackIds);
        filter.filterDate && setFilterDate(filter.filterDate);
    };

    const onResetFilters = () => {
        setFilterArtistIds([]);
        setFilterPlatformIds([]);
        setFilterLabelIds([]);
        setFilterTerritoryIds([]);
        setFilterReleaseIds([]);
        setFilterTrackIds([]);
        setFilterDate([]);
    };

    return {
        filters: {
            filterArtistIds,
            filterLabelIds,
            filterPlatformIds,
            filterTerritoryIds,
            filterReleaseIds,
            filterTrackIds,
            filterDate,
        },
        onSelectFilter,
        onResetFilters,
    };
};